<template>
  <section
    class="component-e505c56b"
    resmed-component-name="4card_carousel_icon-line_text_link"
    v-bind:style="{
      background: acf.layout['background'],
      'padding-top': acf.layout['padding-top'],
      'padding-bottom': acf.layout['padding-bottom'],
    }"
  >
    <div class="component">
      <div class="container text-center headline-text" v-if="acf.headline">
        <div v-if="acf.eyebrowicon" class="pt-5">
          <eyebrow-icon
            v-bind:eyebrowicon="acf.eyebrowicon"
            v-bind:align="'center'"
          ></eyebrow-icon>
        </div>
        <div class="mb-3">
          <h2 class="heading-lg">{{ acf.headline}}</h2>
          <p v-if="acf.description" v-html="acf.description"></p>
        </div>
      </div>

      <div style="overflow: hidden" class="swiper-wrapper">
        <div class="swiper container">
          <div class="row">
            <div
              class="col col-md-10 offset-md-1 col-lg-12 offset-lg-0"
              style="padding: 0"
            >
              <div class="seek">
                <div
                  class="seek-wrapper"
                  v-show="
                    (['md'].includes($root.mode) && acf.items.length > 2) ||
                    (['md', 'lg', 'xl'].includes($root.mode) &&
                      acf.items.length > 4)
                  "
                >
                  <a
                    ref="swiperButtonPrev"
                    href="#"
                    class="btn navigation-icon left-caret swiper-button-prev"
                  ></a>
                  <a
                    ref="swiperButtonNext"
                    href="#"
                    class="btn navigation-icon right-caret swiper-button-next"
                  ></a>
                </div>

                <div
                  ref="swiperContainer"
                  class="swiper-container"
                  v-bind:class="`-mode-${[$root.mode]}`"
                >
                  <div
                    class="items swiper-wrapper"
                    :class="
                      (($root.mode === 'lg' || $root.mode === 'xl') &&
                        acf.items.length < 4) ||
                      ($root.mode === 'md' && acf.items.length < 2)
                        ? 'center-mode'
                        : ''
                    "
                  >
                    <div
                      class="item swiper-slide mb-3 mb-md-0"
                      v-for="(item, index) in acf.items"
                    >
                      <div class="wrapper">
                        <eyebrow-icon
                          v-if="item.eyebrowicon"
                          v-bind:eyebrowicon="item.eyebrowicon"
                        ></eyebrow-icon>
                        <h4 class="heading-xs" v-html="item.title"></h4>
                        <p class="text-md" v-html="item.description"></p>

                        <a
                          v-bind:href="item.cta.href"
                          v-bind:target="item.cta.target"
                          class="flex btn text-red icon textButtonDark"
                          style="display: flex; align-items: center;"
                          >{{ item.cta.text }} &nbsp;
                          <img src="@/assets/images/icon-right-arrow-black.svg" alt="" style="height:0.6rem; width: 0.6rem;" />
                          </a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="row"
            v-show="
              (['xs', 'sm'].includes($root.mode) && acf.items.length > 1) ||
              ($root.mode === 'md' && acf.items.length > 2) ||
              (['lg', 'xl'].includes($root.mode) && acf.items.length > 4)
            "
          >
            <div class="col">
              <div ref="swiperPagination" class="swiper-pagination"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import helper from "../../mixins/swiper-helper";
import scrollTarget from "../../mixins/scroll-target";

export default {
  name: "component-e505c56b", // 4card_carousel_icon-line_text_link
  props: ["acf"],
  data() {
    return {
      slider: undefined,
    };
  },
  mixins: [helper, scrollTarget],
  methods: {
    swhCreate() {
      this.slider = new swiper(this.$refs.swiperContainer, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        freeMode: false,
        freeModeSticky: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          992: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        },
        // loop: true,
        pagination: {
          el: this.$refs.swiperPagination,
          clickable: true,
        },
        navigation: {
          nextEl: this.$refs.swiperButtonNext,
          prevEl: this.$refs.swiperButtonPrev,
        },
      });
    },
  },
  mounted() {
    this.$nextTick(() => this.swhReload());
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-e505c56b {
  padding: 0 0 3rem 0;
}

h2 {
  position: relative;
  margin-bottom: 0.5rem;

  @extend %eyebrow-center;
}

h4 {
  position: relative;
  margin-bottom: 0.625rem;

  @extend %eyebrow-left;
}

p {
  margin: 0 auto 1.5rem auto;
}

.swiper {
  padding: 0 3.5rem;

  @media (min-width: 768px) {
    padding: 0;
    padding-left: 10px;
    padding-right: 10px;
  }
}

.seek-wrapper {
  position: absolute;
  z-index: 1;

  width: 30%;
  bottom: -42px;
  left: 50%;
  transform: translateX(-50%);

  @media (min-width: 992px) {
    width: 20%;
  }

  @media (min-width: 768px) and (max-width: 991px) {
    width: 100%;
    bottom: auto;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  @media (min-width: 1306px) {
    width: 100%;
    bottom: auto;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  a:nth-child(1) {
    float: left;
    transform: translateX(-3rem) scale(1.175);

    @media (min-width: 992px) {
      transform: translateX(-4rem) scale(1.4);
    }
  }

  a:nth-child(2) {
    float: right;
    transform: translateX(3rem) scale(1.175);

    @media (min-width: 992px) {
      transform: translateX(4rem) scale(1.4);
    }
  }
}

.-mode-xs,
.-mode-sm {
  &.swiper-container {
    overflow: visible;
  }
}

.-mode-md,
.-mode-lg,
.-mode-xl {
  &.swiper-container {
    overflow: hidden;
  }
}

.swiper-container {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;

  margin: 0 auto;
  padding: 1rem 0 0.5rem 0;

  @media (min-width: 768px) {
    padding: 1rem 0 2rem 0;
  }
}

.items {
  display: flex;
  align-items: stretch;
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  &.center-mode {
    @media (min-width: 768px) {
      justify-content: center;
    }
  }
}

.item {
  padding: 0 0.625rem;

  display: flex;
  flex-shrink: 0;
  align-items: stretch;

  .wrapper {
    font-family: "Plus Jakarta Sans";
    font-weight: 700;
    padding: 4rem 2rem 3rem 2rem;
    position: relative;
    box-shadow: -1px 0.25rem 12px 2px rgba(0, 0, 0, 0.125);
    // box-shadow: 0 25px 50px 0 rgba(0, 0, 0, 0.15);
    border-radius: 6px;

    background-color: $cc-resmed-white;

    .btn {
      position: absolute;
      bottom: 2rem;
    }
  }
  .proddes{
    font-family:cern-bold,sans-serif !important;
  }
}
</style>
